import { render } from "./BaseTelInput.vue?vue&type=template&id=04975420"
import script from "./BaseTelInput.vue?vue&type=script&lang=js"
export * from "./BaseTelInput.vue?vue&type=script&lang=js"

import "./BaseTelInput.vue?vue&type=style&index=0&id=04975420&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__